// Matches input containing at least one letter or digit
export const ALPHANUMERIC_REGEX = /[a-z0-9]/i;

export function isValidNumber(value) {
  return !isNaN(value);
}

export function isValidDate(dateObject) {
  return new Date(dateObject).toString() !== "Invalid Date";
}

export function isValidOrixId(input) {
  const regex = /\b(OI)-\d+-\d{4}\b/i;
  const id_intitial_regex = /\b(OI)-/i;
  
  return id_intitial_regex.test(input) || regex.test(input);
}

export function calc_days(date1, date2 = null) {
  const ONE_DAY = 1000 * 60 * 60 * 24;
  const dateObj1 = new Date(date1);
  const dateObj2 = date2 ? new Date(date2) : new Date();
  const timeDifference = dateObj2 - dateObj1;
  const dayDifference = Math.round(timeDifference / ONE_DAY);
  return dayDifference;
}
